var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 13.5981V32.5315C37 32.8049 36.952 33.0635 36.8633 33.3073C36.5493 34.1977 35.6996 34.8368 34.6984 34.8368H3.96154C3.02318 34.8368 2.21412 34.2753 1.85946 33.4662V33.4625C1.73016 33.178 1.65997 32.864 1.65997 32.5315V13.5981C1.65997 13.1769 1.77449 12.7816 1.97399 12.4417L13.9991 22.8524H14.0028L18.436 26.6908C18.9495 27.1341 19.7105 27.1378 20.224 26.6945L24.7533 22.8117H24.757L36.7451 12.5452C36.9076 12.8592 37 13.2175 37 13.5981Z",
    stroke: "url(#paint0_linear_3_2)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.77 11.2965C12.2656 11.2965 10.977 11.3039 10.977 11.2965V11.2928H3.96149C3.1118 11.2928 2.36923 11.7546 1.97394 12.4417L13.999 22.8524H14.0027L18.4359 26.6908C18.9494 27.1341 19.7104 27.1378 20.224 26.6945L24.7532 22.8117H24.7569L36.745 12.5452C36.3645 11.7989 35.5887 11.2928 34.6984 11.2928H27.6865C27.6828 11.3002 27.1484 11.2928 26.4531 11.2928",
    stroke: "url(#paint1_linear_3_2)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8596 33.3073L24.757 22.8117",
    stroke: "url(#paint2_linear_3_2)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9991 22.8524L1.85577 33.4662",
    stroke: "url(#paint3_linear_3_2)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7626 10.8642C27.8071 10.868 27.8479 10.8754 27.8887 10.8865C27.8887 10.8791 27.8887 10.8717 27.8924 10.8642H27.7626ZM11.1113 10.8642V10.868C11.1113 10.8754 11.115 10.8791 11.115 10.8865C11.1559 10.8754 11.1967 10.868 11.2375 10.8642H11.1113Z",
    stroke: "url(#paint4_linear_3_2)",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8776 8.06869C27.7329 8.1021 27.5808 8.12067 27.4249 8.12067C26.3453 8.12067 25.4734 7.24451 25.4734 6.16787C25.4734 5.46991 25.8333 4.86105 26.3824 4.51578C25.8518 3.78441 25.2137 3.14585 24.4828 2.61496C24.4605 2.60011 24.4419 2.58155 24.4197 2.57041C24.0783 3.13843 23.455 3.51711 22.7464 3.51711C21.6667 3.51711 20.7911 2.64095 20.7911 1.56059C20.7911 1.40467 20.8097 1.25245 20.8468 1.10766C20.409 1.03341 19.9564 1 19.5 1C19.0362 1 18.5762 1.03713 18.1347 1.11138C18.168 1.25617 18.1829 1.40467 18.1829 1.56059C18.1829 2.64095 17.311 3.51711 16.2313 3.51711C15.5264 3.51711 14.9068 3.14214 14.5655 2.58155C14.5506 2.58897 14.5432 2.5964 14.5284 2.60382C13.7975 3.13472 13.1482 3.7807 12.6213 4.51207C13.1667 4.85734 13.5303 5.46991 13.5303 6.16787C13.5303 7.24451 12.6584 8.12067 11.5788 8.12067C11.4192 8.12067 11.2671 8.1021 11.1224 8.06869C11.0408 8.53276 11 9.01168 11 9.50545C11 9.96952 11.0408 10.4224 11.1113 10.868H11.2375C11.3488 10.8457 11.4638 10.8345 11.5788 10.8345C11.6975 10.8345 11.8125 10.8457 11.9238 10.868C12.8402 11.0276 13.5303 11.8258 13.5303 12.7873C13.5303 13.4927 13.1556 14.1164 12.5917 14.458C12.6028 14.4728 12.6102 14.484 12.6213 14.4988C13.1593 15.2376 13.8123 15.8873 14.5506 16.4182C14.892 15.8465 15.519 15.4641 16.2313 15.4641C17.311 15.4641 18.1829 16.3402 18.1829 17.4169C18.1829 17.584 18.1643 17.7436 18.1235 17.8958C18.1458 17.9032 18.168 17.9032 18.1866 17.9069C18.6133 17.9738 19.0548 18.0072 19.5 18.0072C19.9601 18.0072 20.4127 17.9738 20.8505 17.9032C20.8134 17.7473 20.7911 17.584 20.7911 17.4169C20.7911 16.3402 21.6667 15.4641 22.7464 15.4641C23.4662 15.4641 24.0932 15.8539 24.4308 16.4293C24.4531 16.4182 24.4716 16.4034 24.4939 16.3885C25.2285 15.8502 25.8778 15.1968 26.4046 14.458C25.8481 14.1127 25.4734 13.4927 25.4734 12.7873C25.4734 11.8258 26.1635 11.0276 27.0799 10.868C27.1912 10.8457 27.3062 10.8345 27.4249 10.8345C27.5399 10.8345 27.6512 10.8457 27.7626 10.868H27.8924C27.8924 10.8568 27.8924 10.8457 27.8961 10.8383C27.9629 10.4039 28 9.95838 28 9.50545C28 9.01539 27.9592 8.53276 27.8776 8.06869ZM22.9467 10.0549C22.9208 10.2071 22.8911 10.3519 22.8466 10.493C22.739 10.8642 22.5683 11.2095 22.3531 11.5176C22.1342 11.8332 21.8597 12.1079 21.548 12.3344C21.1251 12.6426 20.6316 12.8579 20.0899 12.9507C19.9007 12.9841 19.7003 13.0027 19.4963 13.0027C19.3145 13.0027 19.1327 12.9878 18.9583 12.9618C18.4092 12.8764 17.9083 12.6648 17.478 12.3567C17.1663 12.1376 16.8955 11.8666 16.6729 11.5585C16.4428 11.2392 16.261 10.8791 16.1497 10.493C16.1089 10.3519 16.0755 10.2145 16.0533 10.0698C16.0236 9.88784 16.0087 9.6985 16.0087 9.50916C16.0087 9.30126 16.0236 9.10449 16.0607 8.90773C16.1534 8.38054 16.3612 7.8942 16.6617 7.47468C16.8806 7.17025 17.1515 6.89553 17.4594 6.67277C17.8898 6.36463 18.3907 6.1493 18.9323 6.0602C19.1179 6.02679 19.3071 6.01565 19.5 6.01565C19.6892 6.01565 19.8784 6.0305 20.0602 6.0602C20.6093 6.1493 21.1139 6.36463 21.548 6.67649C21.8522 6.89924 22.1231 7.17025 22.342 7.4784C22.6388 7.8942 22.8466 8.37683 22.9393 8.9003C22.9727 9.10078 22.9913 9.30126 22.9913 9.50916C22.9913 9.69107 22.9764 9.87299 22.9467 10.0549Z",
    stroke: "url(#paint5_linear_3_2)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_2",
    x1: -4.5,
    y1: 22.5,
    x2: 36.2154,
    y2: 1.77636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_2",
    x1: -6,
    y1: 19,
    x2: 21.7497,
    y2: -6.88716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_2",
    x1: -6,
    y1: 23,
    x2: 43.7687,
    y2: 14.3859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_2",
    x1: -4,
    y1: 21,
    x2: 43.9238,
    y2: 13.0293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_2",
    x1: 10.1205,
    y1: 10.8815,
    x2: 10.6465,
    y2: 13.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_2",
    x1: -3,
    y1: 12.5,
    x2: 43.5,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSettings);
export default __webpack_public_path__ + "static/media/MailSettings.506bf1628d3282251364209b228dd923.svg";
export { ForwardRef as ReactComponent };